import React, { FC } from 'react'
import ProductsPrintConnector, {
  ConnectorProps as ProductsPrintProps,
} from '../../../connectors/ProductsPrint'
import Packaging from './Packaging'
import Options from './Options'
import ForSale from './ForSale'
import { PRINT } from '../../../helpers/constants'

const PrintProducts: FC<ProductsPrintProps> = (props) => {
  const { productType } = props

  if (productType !== PRINT) {
    return null
  }

  return (
    <>
      <Packaging />

      <Options />

      <ForSale />
    </>
  )
}

export default ProductsPrintConnector(PrintProducts)
